export default {
      id: "shape-top-2000-blanc-usage",
      viewBox: "0 0 2000 357.35",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#shape-top-2000-blanc-usage",
      toString: function () {
        return this.url;
      }
    }